import { CustomCountDropdownPopup } from "./custom-count-dropdown";

export const CustomPagination = ({ rowsPerPage, setRowsPerPage, handlePerPageChange, rowCount, onChangePage, currentPage,isDisable=false }) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage);
  const handleFirstPageButtonClick = () => onChangePage(0);
  const handleBackButtonClick = () => onChangePage(parseInt(currentPage) - 1);
  const handleNextButtonClick = () => onChangePage(parseInt(currentPage) + 1);
  const handleLastPageButtonClick = () => onChangePage(totalPages - 1);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
      gap: "10px",
      fontFamily: "Arial, sans-serif"
    }}

    >
      <div className="relative w-[81px]" >
        <CustomCountDropdownPopup onChange={handlePerPageChange} value={rowsPerPage} />
        <div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <svg class="w-5 h-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06-.02L10 10.67l3.71-3.48a.75.75 0 011.06 1.06l-4.24 4a.75.75 0 01-1.06 0l-4.24-4a.75.75 0 01-.02-1.06z" clipRule="evenodd" />
          </svg>
        </div>
      </div>




      <span style={{ fontSize: "14px", color: "#333" }}>
        <span style={{color:"rgba(27, 42, 61, 1)"}} className="font-[600]">{currentPage * rowsPerPage + 1} - {Math.min((currentPage + 1) * rowsPerPage, rowCount)}</span> of <span style={{color:"rgba(27, 42, 61, 1)"}} className="font-[600]">{rowCount}</span> items
      </span>
      <button
        onClick={handleBackButtonClick}
        disabled={currentPage == 0 || isDisable}
        style={{
          border: currentPage == 0 ? "1px solid rgba(36, 92, 234, 0.5)" : "1px solid rgba(36, 92, 234, 1)",
          background: "#fff",
          color: currentPage == 0 ? "rgba(36, 92, 234, 0.5)" : "rgba(36, 92, 234, 1)",
          padding: "1px 10px",
          cursor: "pointer",
          borderRadius: "5px"
        }}
      >
        ‹
      </button>
      <button
        onClick={handleNextButtonClick}
        disabled={(currentPage >= totalPages - 1) || isDisable}
        style={{
          border: currentPage >= totalPages - 1 ? "1px solid rgba(36, 92, 234, 0.5)" : "1px solid rgba(36, 92, 234, 1)",
          background: "#fff",
          color: currentPage >= totalPages - 1 ? "rgba(36, 92, 234, 0.5)" : "rgba(36, 92, 234, 1)",
          padding: "1px 10px",
          cursor: "pointer",
          borderRadius: "5px"
        }}
      >
        ›
      </button>
    </div>
  );
};